import React, { useState } from "react";
import '../assets/styles/Project.scss';

// Import images for TradingAI project
import TradingAI1 from '../assets/images/TradingAI/1.png';
import TradingAI2 from '../assets/images/TradingAI/2.png';
import TradingAI3 from '../assets/images/TradingAI/3.png';
import TradingAI4 from '../assets/images/TradingAI/4.png';
import TradingAI5 from '../assets/images/TradingAI/5.png';

// Import images for AnalyticsDashboard project
import AnalyticsDashboard1 from '../assets/images/AnalyticsDashboard/1.png';
import AnalyticsDashboard2 from '../assets/images/AnalyticsDashboard/2.png';
import AnalyticsDashboard3 from '../assets/images/AnalyticsDashboard/3.png';
import AnalyticsDashboard4 from '../assets/images/AnalyticsDashboard/4.png';

// Import images for VukaMap project
import VukaMap1 from '../assets/images/VukaMap/Overview.png';
import VukaMap2 from '../assets/images/VukaMap/Map.png';
import VukaMap3 from '../assets/images/VukaMap/Hotspots.png';
import VukaMap4 from '../assets/images/VukaMap/Report.png';
import VukaMap5 from '../assets/images/VukaMap/Upload.png';
import VukaMap6 from '../assets/images/VukaMap/AI_Analysis.png';
import VukaMap7 from '../assets/images/VukaMap/Submitted.png';
import VukaMap8 from '../assets/images/VukaMap/Leaderboard.png';
import VukaMap9 from '../assets/images/VukaMap/Events.png';
import VukaMap10 from '../assets/images/VukaMap/Profile.png';

// Import images for CellTowerFrequency project
import CellTower1 from '../assets/images/CellTowerFrequency/CellTowerGraph(2).png';

// Import images for House Pricing project
import HousePricing1 from '../assets/images/HousePricingMachineLearning/1.png';
import HousePricing2 from '../assets/images/HousePricingMachineLearning/2.png';
import HousePricing3 from '../assets/images/HousePricingMachineLearning/3.png';
import HousePricing4 from '../assets/images/HousePricingMachineLearning/4.png';

// Import images for MarbleGame project
import MarbleGame1 from '../assets/images/MarbleGame/as.png';
import MarbleGame2 from '../assets/images/MarbleGame/asd.png';
import MarbleGame3 from '../assets/images/MarbleGame/dasasd.png';
import MarbleGame4 from '../assets/images/MarbleGame/dasd.png';
import MarbleGame5 from '../assets/images/MarbleGame/dasdasd.png';
import MarbleGame6 from '../assets/images/MarbleGame/dsa.png';
import MarbleGame7 from '../assets/images/MarbleGame/dsaz.png';
import MarbleGame8 from '../assets/images/MarbleGame/MarbleGame.gif';

// Import images for VisualNovelEngine project
import VisualNovel1 from '../assets/images/VisualNovelEngine/MainMenu.jpg';
import VisualNovel2 from '../assets/images/VisualNovelEngine/BossFight.jpg';
import VisualNovel3 from '../assets/images/VisualNovelEngine/QuizMechanic.jpg';
import VisualNovel4 from '../assets/images/VisualNovelEngine/RhythmMinigame.jpg';

// PDF served statically from /public/pdfs/
const FrequencyReport = process.env.PUBLIC_URL + '/pdfs/FrequencyAllocationCellPhoneTowers.pdf';

interface ProjectSection {
    header: string;
    points: string[];
}

interface ProjectData {
    title: string;
    subtitle: string;
    stack: string[];
    sections: ProjectSection[];
    images: string[];
    link?: string;
    githubLink?: string;
    videoLink?: string;
    reportLink?: string;
}

const projectsData: ProjectData[] = [
    {
        title: "Agentic Stock Intelligence Platform",
        subtitle: "Full-stack financial analytics platform delivering stock forecasting and weighted investment recommendations.",
        stack: ["Python", "Flask", "Plotly Dash", "Docker", "Ruff", "MyPy"],
        sections: [
            {
                header: "AI Architecture",
                points: [
                    "Multi-LLM agent system powering:",
                    "Real-time news summarization",
                    "Sentiment analysis",
                    "Probabilistic price modeling"
                ]
            },
            {
                header: "Impact",
                points: [
                    "Reduced external API latency by 70% and ensured reliable, research-grade deployments."
                ]
            }
        ],
        images: [TradingAI1, TradingAI2, TradingAI3, TradingAI4, TradingAI5],
        link: "https://trading-analysis-ai.onrender.com/",
        githubLink: "https://github.com/KgFix/AgenticStockIntelligencePlatform"
    },
    {
        title: "Automation & Analytics Dashboard",
        subtitle: "Real-time analytics platform transforming Discord activity into visual insights.",
        stack: ["FastAPI", "Python", "DynamoDB", "Oracle Cloud", "Discord OAuth2", "JWT"],
        sections: [
            {
                header: "Features",
                points: [
                    "Automated OCR-based image processing",
                    "Discord OAuth2 authentication",
                    "JWT-secured services (500+ daily users)",
                    "Parallelized OCR workloads"
                ]
            },
            {
                header: "Performance",
                points: [
                    "Improved system throughput by 60%",
                    "Low-latency insights with high-performance DynamoDB schema"
                ]
            }
        ],
        images: [AnalyticsDashboard1, AnalyticsDashboard2, AnalyticsDashboard3, AnalyticsDashboard4],
        link: "https://haikyuucontestdashboard.netlify.app/",
        githubLink: "https://github.com/KgFix/HaikyuuContestDashboard"
    },
    {
        title: "VukaMap",
        subtitle: "Gamified pollution tracking platform for South African townships.",
        stack: ["C#", "ASP.NET Core", "React", "Azure Computer Vision", "GPS"],
        sections: [
            {
                header: "Core Features",
                points: [
                    "AI-validated before/after images",
                    "Real-time heatmaps and leaderboards",
                    "GPS-based location authentication",
                    "Pollution severity scoring"
                ]
            },
            {
                header: "Architecture",
                points: [
                    "REST API with ASP.NET Core backend",
                    "React frontend with Azure Computer Vision integration"
                ]
            }
        ],
        images: [VukaMap1, VukaMap2, VukaMap3, VukaMap4, VukaMap5, VukaMap6, VukaMap7, VukaMap8, VukaMap9, VukaMap10],
        githubLink: "https://github.com/KgFix/pollution_mapping-social_tracker-za",
        videoLink: "https://youtu.be/FF2OUC6ljBA?si=o_Cqyd-Q46uFd4XE"
    },
    {
        title: "Housing Price Regression Analysis",
        subtitle: "Machine learning EDA project uncovering the key variables driving residential property prices and building a clean foundation for predictive modeling.",
        stack: ["Python", "Pandas", "NumPy", "Matplotlib", "Seaborn", "Jupyter Notebook"],
        sections: [
            {
                header: "Analysis",
                points: [
                    "End-to-end EDA: cleaning, feature engineering, correlation mapping",
                    "Outlier detection and skewness analysis across all features",
                    "Heatmap and pairplot visualizations identifying price drivers"
                ]
            },
            {
                header: "Insights",
                points: [
                    "Isolated top features most correlated with sale price",
                    "Detected skew requiring log-transformation for regression",
                    "Flagged multicollinearity risks between structural and location features"
                ]
            }
        ],
        images: [HousePricing1, HousePricing2, HousePricing3, HousePricing4],
        githubLink: "https://github.com/KgFix/HousingPriceMachineLearningAnalysis"
    },
    {
        title: "Frequency Allocation Engine",
        subtitle: "Command-line optimization engine assigning radio frequencies to cell towers while minimizing signal interference under strict spectrum constraints.",
        stack: ["Java", "Graph Theory", "Priority Queues", "Euclidean Geometry", "CSV Processing"],
        sections: [
            {
                header: "Architecture",
                points: [
                    "Graph Coloring–based allocation algorithm",
                    "Custom density-weighted PriorityScore heuristic",
                    "Squared-distance optimization — no sqrt overhead"
                ]
            },
            {
                header: "Engineering",
                points: [
                    "Interference modeled as a Graph Coloring constraint problem",
                    "Dynamic N-nearest neighbor topology per frequency count",
                    "Automated chromatic conflict detection and reporting",
                    "Dataset-agnostic - scalable to any tower/frequency setup"
                ]
            }
        ],
        images: [CellTower1],
        reportLink: FrequencyReport,
        githubLink: "https://github.com/KgFix/FrequencyAllocation"
    },
    {
        title: "Marble Game",
        subtitle: "Unity/C# 3D physics platformer with procedural generation.",
        stack: ["Unity", "C#", "3D Physics"],
        sections: [
            {
                header: "Game Modes",
                points: [
                    "Third-person marble roller",
                    "Procedurally generated side-scroller",
                    "Custom-animated boss fight"
                ]
            }
        ],
        images: [MarbleGame1, MarbleGame2, MarbleGame3, MarbleGame4, MarbleGame5, MarbleGame6, MarbleGame7, MarbleGame8],
        githubLink: "https://github.com/KgFix/Marble"
    },
    {
        title: "Visual Novel Game Engine",
        subtitle: "2D story-based quiz game built from scratch.",
        stack: ["C++", "SFML"],
        sections: [
            {
                header: "Features",
                points: [
                    "Various minigames",
                    "Decision-based storylines",
                    "Final boss fight"
                ]
            }
        ],
        images: [VisualNovel1, VisualNovel2, VisualNovel3, VisualNovel4],
        githubLink: "https://github.com/leshenn/VisualNovelGame"
    }
];

function ProjectCard({ project, alignLeft }: { project: ProjectData; alignLeft: boolean }) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [collapsedSections, setCollapsedSections] = useState<{[key: number]: boolean}>({});

    const cycleImage = () => {
        if (project.images.length > 1) {
            setCurrentImageIndex((prevIndex) => 
                (prevIndex + 1) % project.images.length
            );
        }
    };

    const toggleSection = (index: number) => {
        setCollapsedSections(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const ImageSection = () => (
        <div className="project__image-container">
            <div className="project__image-image">
                <img 
                    src={project.images[currentImageIndex]} 
                    alt={`${project.title} screenshot`}
                    onClick={cycleImage}
                    style={{ cursor: project.images.length > 1 ? 'pointer' : 'default' }}
                />
            </div>
        </div>
    );

    const InfoSection = () => (
        <div className="project__info">
            <h3 className="project__title">{project.title}</h3>
            <p className="project__subtitle">{project.subtitle}</p>
            
            <div className="project__divider"></div>
            
            <div className="project__stack-section">
                <span className="project__stack-label">Tech Stack</span>
                <div className="project__stack-tags">
                    {project.stack.map((tech, index) => (
                        <span key={index} className="project__stack-tag">{tech}</span>
                    ))}
                </div>
            </div>

            <div className="project__sections-grid">
                {project.sections.map((section, index) => (
                    <div key={index} className="project__section">
                        <h4 
                            className={`project__section-header ${collapsedSections[index] ? 'collapsed' : ''}`}
                            onClick={() => toggleSection(index)}
                        >
                            {section.header}
                        </h4>
                        <ul className={`project__section-points ${collapsedSections[index] ? 'collapsed' : ''}`}>
                            {section.points.map((point, pointIndex) => (
                                <li key={pointIndex}>{point}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <div className="project__buttons">
                {project.videoLink && (
                    <a href={project.videoLink} target="_blank" rel="noreferrer">
                        <div className="project__live-2 primary">Video</div>
                    </a>
                )}
                {project.reportLink && (
                    <a href={project.reportLink} target="_blank" rel="noreferrer">
                        <div className="project__live-2 primary">Report</div>
                    </a>
                )}
                {project.link && (
                    <a href={project.link} target="_blank" rel="noreferrer">
                        <div className="project__live-2 primary">View Live App</div>
                    </a>
                )}
                {project.githubLink && (
                    <a href={project.githubLink} target="_blank" rel="noreferrer">
                        <div className="project__live-2 secondary">Learn More</div>
                    </a>
                )}
            </div>
        </div>
    );

    return (
        <div className={`project ${alignLeft ? 'project-left' : 'project-right'}`}>
            <ImageSection />
            <InfoSection />
        </div>
    );
}

function Project() {
    return (
        <section className="projects" id="projects">
            <h2 className="projects__heading section-heading">Projects</h2>
            
            {projectsData.map((project, index) => (
                <ProjectCard 
                    key={index} 
                    project={project} 
                    alignLeft={index % 2 === 0}
                />
            ))}
        </section>
    );
}

export default Project;